@if (suggestedProducts$ | async; as suggestProducts) { @if (suggestProducts.length) {
<div class="product-list-container suggest-details">
  <h2>{{ productLinkTitle() }}</h2>
  <div class="product-list" [ngClass]="getClass(suggestProducts.length)">
    @for (suggestedProduct of suggestProducts; track suggestedProduct; let suggestedProductIndex = $index) {
    <ng-container ishProductContext [sku]="suggestedProduct.sku">
      @if (suggestedProductIndex < 3) {
      <div class="product-list-item list-view">
        <div class="row">
          <div class="product-image-container col-5">
            <ish-product-image imageType="S" [link]="true" />
          </div>
          <div class="col-7 suggest-prod-info">
            <ish-product-name />
            <div>{{ suggestedProduct.sku }}</div>
            <ish-product-price [showInformationalPrice]="true" />
          </div>
        </div>
        <!-- <div class="w-100 d-flex">
                <div class="w-100">
                  <ish-product-quantity></ish-product-quantity>
                </div>
                <div class="w-100">
                  <ish-product-add-to-basket></ish-product-add-to-basket>
                </div>
              </div> -->
        <div class="custom-add-to-cart d-flex mb-0 pdp-buttons-padding">
          <div class="custom-add-to-cart-input mr-2 pdp-qun-btn-height">
            <ish-product-quantity id="product-detail-quantity" />
          </div>
          <div class="custom-add-to-carte-btn mb-0">
            <ish-product-add-to-basket [cssClass]="'btn-lg btn-block'" />
          </div>
        </div>
      </div>
      }
    </ng-container>
    }
  </div>
</div>
} }
